
import React, { useEffect, useState, useContext,useRef } from 'react';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import {timesheetreportService} from '../../services/timesheetreportsService';
import {timesheetService} from '../../services/timesheetService';
import {timesheetuserService} from '../../services/timesheetUserservice';
import {formatterhelper} from '../../helpers/dateformatter';
import { Paginator } from 'primereact/paginator';
import {loader} from '../../compnents/loadermd';
import { Dialog } from 'primereact/dialog';
import { FaBeer,FaCheck,FaEdit,FaRecycle,FaSearch,FaCross, FaTrash } from "react-icons/fa";
import Smallloader from '../../compnents/loader';
import {adminService} from '../../services/adminService';
import { Toast } from 'primereact/toast';
import { Message } from 'primereact/message';
import { ToggleButton } from 'primereact/togglebutton';
import { func } from 'prop-types';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import {Mandate} from '../../compnents/formcomp';

const Mapmainclient = ({tabname}) => {
    const toast = useRef(null);
    const [formData, setFormData] = useState({
        selectedclient: '',
        type:'',
        new_client_name:''
      });
    const [datacomp,setDatacomp] = useState([]); 
    const [datacomptemp,setDatacomptemp] = useState([]); 
    const [projcomp,setProjcomp] = useState([]); 
    const [budgethrs,setbudgethrs] = useState([]); 
    const [clientcomp,setClientcomp] = useState([]); 
    const [usercomp,setUsercomp] = useState([]); 
    const [rdsdatacomp,setrdsDatacomp] = useState([]); 
    const [dataavail,setDatastate] = useState(false); 
    const [cleintscomp,setClientscomp] = useState([]); 
    const [subclientscomp,setsubClientscomp] = useState([]); 
    const [subtaskscomp,settaskscomp] = useState([]);
    const [subclientLoader,setSubclientloader] = useState(<></>);
    const [remainloaded,setreminloader] = useState(true);
    const [empcomp,setempcomp] = useState([]); 
    const [totalpages,setPages] = useState(0);
    const [filterobj,setfilterobj] = useState({});
    const userdata = localStorage.getItem('user') != '' ? JSON.parse(localStorage.getItem('user')) : {};
    const [isloaded,setloading] = useState(true);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(15);
    const [addtimesheettoggle,settoggle] = useState(false); 
    const [editobj,seteditobj] = useState({'client':'','budget':''});
    const [errors, setErrors] = useState({});
    const [editerrors, seteditErrors] = useState({});
    const [newobjdata, setNewobj] = useState({});
    const [isclientmerge, setclientmerge] = useState(false);
    const [rolename, setRoleName] = useState(false);
    const [allsubclients,setallsubClients] = useState([]);
     
    useEffect(()=>{
        const roleData = localStorage.getItem('role');
        if (roleData) {
            setRoleName(rolename);
            // console.log(JSON.parse(roleData).rolename);
        }
        getallclient();
        // getclientwisebudget();
    },[]);

    const handleChange = (e) => {
        try{
            const { name, value } = e.target;
            setFormData((prevData) => ({
              ...prevData,
              [name]: value,
            }));

            let selected_client = '';
            if(name == 'selectedclient'){
                selected_client = value;
                getallsubclients({client:selected_client}); 
            }
    
        }catch(e){
            console.log(e);
        }
        
    };

    const validateForm = () => {
        let valid = true;
        const newErrors = {};
        if (formData.selectedclient == '') {
            newErrors.selectedclient = 'Client is required';  
            valid = false;
        }

        // if (formData.type == '') {
        //     newErrors.type = 'Type is required';  
        //     valid = false;
        // }
        if (formData.new_client_name == '') {
            newErrors.new_client_name = 'New Client Name is required'; 
            valid = false;
        }
        if (formData.project_id == '') {
            newErrors.project_id = 'Project selection is required'; 
            valid = false;
        }
        setErrors(newErrors);
       return valid; 
    }

    const validateForm2 = () => {
        let valid = true;
        const newErrors = {};
        if (formData.selectedclient == '') {
            newErrors.selectedclient = 'Client is required';  
            valid = false;
        }
        if (formData.type == '') {
            newErrors.type = 'Type is required';  
            valid = false;
        }
        if (formData.monthmdl == '') {
            newErrors.monthmdl = 'Month is required';
            valid = false;
        }
        // if (formData.project_id == '') {
        //     newErrors.project_id = 'Project selection is required'; 
        //     valid = false;
        // }
        setErrors(newErrors);
       return valid;  
    }

   

   

    const handleSubmit = (e) => {
        e.preventDefault();
        if(!validateForm()){
            return;
        }
       mapclient();
       setFormData({
        new_client_name:'',
       });
    //    e.target.name
    };


    
    const validateFormedit = () => {
        let valid = true;
        const newErrors = {};
        if (editobj.client == '') {
            newErrors.client = 'Client is required';
            valid = false;
        }

        if (editobj.budget == '') {
            newErrors.budget = 'Budget is required'; 
            valid = false;
        }
        seteditErrors(newErrors);
        return valid; 
    }

    

    function mapclient(){
    //   formData.month = formatterhelper.dateformatter({date:formData.monthmdl});
      let obj = JSON.stringify(formData); 
        // console.log(obj);
        toast.current.show({severity:'success', summary: "Client Mapping", detail:`Client Mapped successfully`, life: 3000}); 
        // setFormData({selectedclient:''});
        // setFormData({project_id:''});
        // setFormData({new_client_name:''});
        timesheetService.mapclient({formdata:obj}).then((response)=>{
            //   console.log(response);
            if(response.status == 200){
                toast.current.show({severity:'success', summary: "Client Mapping", detail:`Client Mapped successfully`, life: 3000}); 
            }else{
                toast.current.show({severity:'error', summary: "Client Mapping", detail:`Something is wrong`, life: 3000}); 
            }
        }).catch((error)=>{
            toast.current.show({severity:'error', summary: "Client Mapping", detail:`Error`, life: 3000}); 
        }); 
    }
 
    function getallclient(){
        let emparr = [];
        adminService.getallclient().then((response)=>{
           response.data.data.forEach((value,index)=>{
            if(value.client != ''){
                emparr.push(<option value={value.client}>{value.client}</option>);
            }
           
           });
           setClientcomp(emparr);
        }).catch((error)=>{
           console.log(error);  
        });   
    }

    function  getallsubclients({client}){
        try{
           let emparr = [];
           setreminloader(false);
           setSubclientloader((<Smallloader/>));
           return adminService.getprojectbyclient({client:client}).then((response)=>{
              if(response == undefined || response == '' || response.data.data == undefined){
                    return;
              }
              response.data.data.forEach((value,index)=>{
                 emparr.push((<option key={index} value={value.id}>{value.name}</option>)); 
              });
              setsubClientscomp(emparr);
              setSubclientloader((<></>));
              setallsubClients(response.data.data);
              setreminloader(true);
              return response.data.data;
           }).catch((error)=>{
              console.log(error);  
              setSubclientloader((<></>));
              setreminloader(true);
           });   
        }catch(error){
           console.log(error);
        }
     }

   

 return (
        <>
            <Toast ref={toast} />
            <ConfirmDialog /> 
            <div className="invisible-divider-sm"></div>
            <h6 className='card-style-padding-two'>{tabname}</h6>
            <div className='card card-custom-style card-style-padding'>
             
            
              <form onSubmit={handleSubmit}>
                <div className='row'>
                   <div className='col-md-12'>
                <div className='row'>
                    <div className='col-md-12'>
                        <div class="card card-custom-style card-custom-height bg-warning">
                            <div class="card-body">
                                <p class="quote-text-style quote-text-style-color">Notes —</p>
                                <small class="">Please ensure that during the process of renaming, certain consideration taken in to account:</small>
                                {/* <ol> */}
                                    <li><small class="">1.While updating main client,the new client name splelling should has to be proper. </small></li>
                                {/* </ol> */}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-4">
                    <br/>
                        <label className='pull-left'><Mandate/> </label>
                        <br/>
                        <select className='custom-dropdown-style' name="type" class="form-control" >
                        <option value="all" selected>ALL</option>
                        </select>
                        {errors.type && <span className='error'>{errors.type}</span>}
                    </div> 
                    
                   <div className="col-md-4">
                   <br/>
                        <label className='pull-left'><Mandate/> Client</label>
                        <br/>
                        <select className='custom-dropdown-style' name="selectedclient" class="form-control" onChange={(e) => handleChange(e)}>
                           <option value="">Select Client</option>
                           <option value="all">ALL</option>
                           {clientcomp}
                        </select>
                        
                        {errors.selectedclient && <span className='error'>{errors.selectedclient}</span>}
                    </div>

                    <div className="col-md-4">
                    <br/>
                        <label className='pull-left'><Mandate/>Project</label>
                        <br/>
                        <select className='custom-dropdown-style' name="project_id" class="form-control" onChange={(e) => handleChange(e)}>
                           <option value="">Select Project</option>
                           {subclientscomp}
                        </select>
                        
                        {errors.project_id && <span className='error'>{errors.project_id}</span>}
                    </div>

                     <div className="col-md-4">
                       <br/>
                        <label className='pull-left'><Mandate/>New Client Name</label>
                        <input type='text' name="new_client_name"  className='form-control' value={formData.new_client_name}  onChange={(e) => handleChange(e)}/>
                        <br/>
                        {errors.new_client_name && <span className='error'>{errors.new_client_name}</span>}
                    </div>  

                    <div className="col-md-12 col-sm-12">
                      
                      <div className='container-box'>
                         {/* <div className='button-wrapper-style'>
                            <Button type='button'  label="Show" onClick={() => getclientwisebudget()} severity="success" rounded className='custom-btn-style col-md-12' />
                        </div>
                        &nbsp;
                        &nbsp; */}

                        <div className='button-wrapper-style'>
                           {formData.selectedclient != 'all' ? (<Button type='submit' stype="button" label="Submit" severity="success" rounded className='custom-btn-style col-md-12' />) : (<></>)} 
                        </div>  
                      </div>
                       
                     </div>
                </div>
                <br/>
                <br/>
               
                </div>
               
                </div>
                </form>
                
            </div>

        </>
    );
}

export default Mapmainclient;
